/**
 * OmyBoat - Ports Search v2 (optimisé)
 * Niveau 1 : lookup local VILLES_META avant Photon
 * Niveau 2 : cache sessionStorage des résultats Photon
 * Niveau 3 : debounce 500ms
 */

(function () {
  'use strict';

  var radius    = 25;
  var geoTimer  = null;
  var lastGeo   = null;

  var input     = document.getElementById('portsSearchInput');
  var radiusRow = document.getElementById('portsRadiusRow');
  var quickSec  = document.getElementById('portsQuickSection');

  if (!input) return;

  var VILLES = window.OMYBOAT_VILLES_META || [];
  var PORTS_FLAT = [];
  VILLES.forEach(function (city) {
    (city.ports || []).forEach(function (port) {
      PORTS_FLAT.push({ slug:port.slug, nom:port.nom, ville:city.ville, citySlug:city.slug, lat:city.lat, lng:city.lng, emoji:city.emoji, anneaux:port.anneaux, taille:port.taille, note:port.note, dept:city.departement_nom });
    });
  });

  var fuse = new Fuse(PORTS_FLAT, { keys:[{name:'nom',weight:1.0}], threshold:0.35, minMatchCharLength:3, includeScore:true, ignoreLocation:true });

  function findLocalCity(q) {
    var qL = q.toLowerCase().trim();
    if (qL.length < 2) return null;
    return VILLES.find(function(v){ return v.ville.toLowerCase()===qL; })
      || VILLES.find(function(v){ return v.slug===qL||v.slug.replace(/-/g,' ')===qL; })
      || (qL.length>=3 && VILLES.find(function(v){ return v.ville.toLowerCase().startsWith(qL); }))
      || (qL.length>=4 && VILLES.find(function(v){ return v.ville.toLowerCase().includes(qL); }))
      || null;
  }

  function cachedGeocode(q, cb) {
    var key = 'omyb_geo_' + q.toLowerCase().trim();
    try { var c=sessionStorage.getItem(key); if(c){cb(null,JSON.parse(c));return;} } catch(e){}
    window.portsGeocode(q, function(err, results) {
      if (!err && results && results.length>0) { try{sessionStorage.setItem(key,JSON.stringify(results));}catch(e){} }
      cb(err, results);
    });
  }

  function buildNearby(cities, directMatches) {
    var ids={}; cities.forEach(function(c){(c.ports||[]).forEach(function(p){ids[p.slug]=true;});});
    return directMatches.filter(function(p){return !ids[p.slug];});
  }

  function handleSearch(q) {
    if (q.length<2) { window.portsHideDropdown(); if(quickSec)quickSec.style.display='block'; if(radiusRow)radiusRow.classList.remove('visible'); return; }
    if(quickSec)quickSec.style.display='none';
    window.portsShowSpinner(true);
    var dM=fuse.search(q).filter(function(r){return r.score<0.15;}).map(function(r){return r.item;});

    var local=findLocalCity(q);
    if (local) {
      window.portsShowSpinner(false);
      lastGeo={lat:local.lat,lng:local.lng,label:local.ville};
      var cs=window.portsNearbyCities(local.lat,local.lng,radius);
      if(radiusRow)radiusRow.classList.add('visible');
      window.portsRenderDropdown(lastGeo,cs,buildNearby(cs,dM),q,radius);
      return;
    }

    cachedGeocode(q, function(err,gR) {
      window.portsShowSpinner(false);
      var cs=[];
      if(!err&&gR&&gR.length>0){lastGeo=gR[0];cs=window.portsNearbyCities(lastGeo.lat,lastGeo.lng,radius);if(radiusRow)radiusRow.classList.add('visible');}
      var ex=buildNearby(cs,dM);
      if(!cs.length&&!ex.length){var l=fuse.search(q).slice(0,5).map(function(r){return r.item;});if(l.length)window.portsRenderDropdown(null,[],l,q,radius);else window.portsRenderEmpty(q);return;}
      window.portsRenderDropdown(gR[0]||null,cs,ex,q,radius);
    });
  }

  window.portsSelectCity=function(s,v){var c=VILLES.find(function(x){return x.slug===s;});if(!c)return;input.value=v;window.portsHideDropdown();if(radiusRow)radiusRow.classList.remove('visible');window.portsRenderCityCard(c);};
  window.portsSelectPort=function(ps,cs){var c=VILLES.find(function(x){return x.slug===cs;});if(!c)return;var p=(c.ports||[]).find(function(x){return x.slug===ps;});if(!p)return;input.value=p.nom;window.portsHideDropdown();if(radiusRow)radiusRow.classList.remove('visible');if(quickSec)quickSec.style.display='none';window.portsRenderPortCard(p,c);};
  window.portsReset=function(){var c=document.getElementById('portsSelectedCard');if(c){c.classList.remove('visible');c.innerHTML='';}input.value='';input.focus();if(quickSec)quickSec.style.display='block';window.portsHideDropdown();};
  window.portsSetRadius=function(r,el){radius=r;document.querySelectorAll('.radius-pill').forEach(function(p){p.classList.remove('active');});el.classList.add('active');if(lastGeo){var c=window.portsNearbyCities(lastGeo.lat,lastGeo.lng,radius);window.portsRenderDropdown(lastGeo,c,[],input.value,radius);}};
  window.portsLocateMe=function(){if(!navigator.geolocation){alert('Geolocalisation non disponible.');return;}input.value='Localisation...';input.disabled=true;window.portsShowSpinner(true);navigator.geolocation.getCurrentPosition(function(pos){input.disabled=false;window.portsShowSpinner(false);var lat=pos.coords.latitude,lng=pos.coords.longitude;input.value='Ma position';lastGeo={lat:lat,lng:lng,label:'votre position'};var c=window.portsNearbyCities(lat,lng,radius);window.portsRenderDropdown(null,c,[],'' ,radius);if(radiusRow)radiusRow.classList.add('visible');if(quickSec)quickSec.style.display='none';},function(){input.disabled=false;window.portsShowSpinner(false);input.value='';alert('Geolocalisation refusee. Tapez votre ville.');});};
  window.portsQuickSearch=function(q){input.value=q;if(quickSec)quickSec.style.display='none';clearTimeout(geoTimer);handleSearch(q);};

  input.addEventListener('input',function(e){clearTimeout(geoTimer);var q=e.target.value.trim();if(q.length<2){handleSearch(q);return;}geoTimer=setTimeout(function(){handleSearch(q);},500);});
  input.addEventListener('focus',function(){if(input.value.trim().length>=2){var d=document.getElementById('portsDropdown');if(d)d.classList.add('visible');}});
  document.addEventListener('click',function(e){var w=document.querySelector('.search-widget');if(w&&!w.contains(e.target))window.portsHideDropdown();});

})();
